'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './meeting-edit.routes';

export class MeetingEditComponent {
  constructor(MeetingService, dialogs, User, $stateParams, $state, Auth) {
    'ngInject';
    this.Auth = Auth;
    this.MeetingService = MeetingService;
    this.dialogs = dialogs;

    this.$state = $state;

    this.meeting = {
      meta: {
        creationUser: this.Auth.getCurrentUserSync()._id
      }
    };

    this.users = [];
    User.query(data => {
      this.users = data.filter(user => user.active && user.role.includes('member')).map(user => {
        user.nameAndCompany = user.firstName + " " + user.lastName + " - " + user.companyName;
        return user;
      });
    });

    this.meetingId = $stateParams.id;

    this.titlePrefix = (this.meetingId) ? "Edit" : "Create";

    if (this.meetingId) {
      this.MeetingService.get({id: this.meetingId}, data => {
        this.meeting = data;
        this.meeting.date = new Date(data.date);
      }, err => {
        console.log('Could not load meeting from server');
      })
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.meetingId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The one on one has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("meeting-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.meetingId) {  // Save changes on the current meeting
        this.MeetingService.update({id: this.meetingId}, this.meeting, onSuccess, onError);
      } else { // Create new settings
        this.MeetingService.save(this.meeting, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduuApp.meetingEdit', [uiRouter])
  .config(routes)
  .component('meetingEdit', {
    template: require('./meeting-edit.html'),
    controller: MeetingEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/meeting/edit/meeting-edit.component.js